// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ChannelUsers_wrap__yvNEz","loading":"ChannelUsers_loading__19JK7","user":"ChannelUsers_user__2x1Mt","action":"ChannelUsers_action__34OdH","add":"ChannelUsers_add__3Hxlm"};